export default __webpack_public_path__ + "static/media/googleplay.2df58015.png";